import styled from 'styled-components'

type Props = {
  $direction?: string
  $padding?: number
}

const Grid = styled.div<Props>`
  display: flex;
  box-sizing: border-box;
  flex-direction: ${(props: Props) => (props.$direction ? props.$direction : 'row')};
  padding: ${(props: Props) => props.$padding}px;
  & > * {
    flex: 1;
  }
`

Grid.defaultProps = {
  $direction: 'row',
  $padding: 16,
}

export default Grid
